import HomeschoolBaseTile from 'teacher-ui-client/components/home/tiles/homeschool/base-tile'
import { t } from 'ember-intl'
import { TileButton } from 'teacher-ui-client/components/home/tiles/homeschool/button'
import certificates from '@images/homeschool-ui-icons/certificate_blue.svg'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import type { TOC } from '@ember/component/template-only'

export const CertificatesTile: TOC<unknown> = <template>
  <HomeschoolBaseTile
    @themeKey={{ThemeKeys.green}}
    @imgSrc={{certificates}}
    @imgAlt={{t "pages.home.panels.homeschool.certificates.imageAlt"}}
    @title={{t "pages.home.panels.homeschool.certificates.title"}}
    @tileDescription={{t "pages.home.panels.homeschool.certificates.description" htmlSafe=true}}
  >
    <div class="flex flex-col items-center space-y-4 text-center">
      <TileButton
        @title={{t "pages.home.panels.homeschool.certificates.buttonText"}}
        @themeKey={{ThemeKeys.blue}}
        @route="manage.certificates"
        data-test-homeschool-certificates-button
      />
    </div>
  </HomeschoolBaseTile>
</template>

export default CertificatesTile
